import {Timer} from "js-vextensions";
import {EngineConfig_General} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_General.js";
import {LiveSession} from "../../LiveSession.js";
import {EngineSessionComp} from "./EngineSessionComp.js";
import {secondInMS} from "web-vcore";
import {WebAudioPlayerPool} from "../../../Utils/Media/WebAudioPlayer.js";
import {Device} from "@capacitor/device";
import {EffectPointerPlayer} from "../../../Server/DB/@Shared/EffectPointerPlayer.js";

export class GeneralComp extends EngineSessionComp<EngineConfig_General> {
	constructor(session: LiveSession, config: EngineConfig_General) {
		super(session, config, s=>true, s=>s.IsLocal());
	}

	webAudioPlayerPool = new WebAudioPlayerPool();

	override OnActivate() {
		this.heartbeatTimer.Start();
	}
	override OnDeactivate(sessionStopping: boolean) {
		this.heartbeatTimer.Stop();
	}

	heartbeatTimer = new Timer(25, ()=>{
		this.recentHeartbeats.push({time: Date.now()});

		// remove older-than-10-seconds heartbeats
		const minHeartbeatTimeToKeep = Date.now() - 10_000;
		while (this.recentHeartbeats.length > 0 && this.recentHeartbeats[0].time < minHeartbeatTimeToKeep) {
			this.recentHeartbeats.shift();
		}
	});
	recentHeartbeats = [] as {time: number}[]; // added every 25ms

	// todo: gradually move logic here from LiveSession/LiveSession_Local (if it fits)
}